module.exports = __webpack_public_path__ + "img/kasper.a532ac83.png";